// Mirror of Post.tag_slug in Ruby. Tags are stored as human strings ("getting
// started") but each has exactly one canonical URL segment; linking to the raw
// value produced /blog/tag/getting%20started, which resolves but reads as
// broken in a search result. The server 301s any non-canonical form, so this
// only avoids a needless redirect hop.
export function tagSlug(tag: string): string {
  return tag.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")
}
